// The languages endpoint returns locale-style codes (e.g. 'fr_fr', 'sp_es'),
// but topic translations are stored as 2-letter ISO codes (e.g. 'fr', 'es').
// This map keeps stored translation languages 2 characters long.
const LOCALE_TO_ISO: { [localeCode: string]: string } = {
  en_gb: 'en',
  en_us: 'en',
  fr_fr: 'fr',
  de_de: 'de',
  it_it: 'it',
  sp_es: 'es',
};

export function toIsoLanguage(code: string): string {
  if (!code) {
    return '';
  }
  const normalised = code.trim().toLowerCase();
  return LOCALE_TO_ISO[normalised] ?? normalised.slice(0, 2);
}
